(() => {
  const ticket = document.querySelector('[data-cv-floating-cart]');
  if (!ticket || ticket.dataset.initialized) return;
  const bar = ticket.closest('[data-cv-try-bar]') || ticket;
  const previewForm = document.getElementById('store-preview-form');
  ticket.dataset.initialized = 'true';

  let frame = 0;
  let launchedHere = false;
  let closeObserver;
  const update = () => {
    frame = 0;
    // The app fixes the body while its drawer is open. Keep the launcher's
    // visibility stable so the app can return keyboard focus after closing.
    if (launchedHere || document.body.style.position === 'fixed') return;
    // Real scroll progress reveals an invitation; it never opens the drawer.
    const revealAt = Math.max(240, Math.min(480, window.innerHeight * .55));
    const formBounds = previewForm?.getBoundingClientRect();
    const formVisible = formBounds && formBounds.top < window.innerHeight && formBounds.bottom > 0;
    bar.hidden = window.scrollY < revealAt || Boolean(formVisible);
  };
  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(update);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', schedule);
  update();

  const watchDrawerClose = () => {
    closeObserver?.disconnect();
    const app = document.getElementById('cartivate-root');
    const host = app && Array.from(app.querySelectorAll('*')).find(el => el.shadowRoot);
    const tree = host?.shadowRoot;
    if (!tree) { launchedHere = false; return; }
    let dialog;
    const check = () => {
      if (!dialog) {
        dialog = tree.querySelector('[role="dialog"][aria-modal="true"]');
      } else if (!dialog.isConnected) {
        closeObserver.disconnect();
        launchedHere = false;
        // Wait for the real drawer's exit, after its scroll and focus cleanup.
        window.requestAnimationFrame(() => {
          const active = document.activeElement;
          if (active === document.body || active === ticket || app.contains(active)) {
            ticket.focus({ preventScroll: true });
          }
        });
      }
    };
    closeObserver = new MutationObserver(check);
    closeObserver.observe(tree, { childList: true, subtree: true });
    check();
  };

  ticket.addEventListener('click', () => {
    // The installed app owns products, offers, focus trapping and dismissal.
    ticket.focus({ preventScroll: true });
    launchedHere = true;
    watchDrawerClose();
    if (typeof window.AppCartDrawer?.open === 'function') {
      window.AppCartDrawer.open();
    } else {
      document.getElementById('cart-icon-bubble')?.click();
    }
  });
})();
